export interface Navigation {
  href: string
  key: string
  name: string
  home?: boolean
}

export const homeNavigation: Navigation = {
  name: `XRPL Grants`,
  home: true,
  href: `/`,
  key: `home`,
}

export const navigation: Navigation[] = [
  {
    name: `About`,
    href: `/about`,
    key: `about`,
  },
  {
    name: `FAQ`,
    href: `/faq`,
    key: `faq`,
  },
  homeNavigation,
  {
    name: `Grantees`,
    href: `/grantees`,
    key: `grantees`,
  },
  {
    name: `Judges`,
    href: `/judges`,
    key: `judges`,
  },
]
